import { defineMessages } from 'react-intl'

export default defineMessages({
  error: {
    id: 'containers.UserSignIn.error',
    defaultMessage: 'Error',
  },
  redirectedTo1: {
    id: 'containers.UserSignIn.redirectedTo1',
    defaultMessage: 'You will be redirected to',
  },
  redirectedTo2: {
    id: 'containers.UserSignIn.redirectedTo2',
    defaultMessage: 'after you have successfully signed in.',
  },
  keychainHint: {
    id: 'containers.UserSignIn.keychainHint',
    defaultMessage: 'We have recently moved from system.voicearchive.com. Your saved login may still be stored under the old address - search your password manager for "voicearchive" and update the address.',
  },
})
